
import { AsciiFileCurrencyOptionEnum } from '~modules/connectors/modules/load/common/ascii-file-currency-options';
import { AccountingEntryNumberModeEnum } from '~modules/connectors/modules/load/common/services/accounting-number-mode.service';
import { DocumentOptionEnum } from '~modules/connectors/modules/load/common/services/document-option.service';
import { LetteringScopeEnum } from '~modules/connectors/modules/load/common/services/lettering-scope.service';
import { AsciiDownloadFieldsConfiguration } from '~modules/connectors/services/extract-connectors-configurations/field-type';

export const asciiDownLoadFieldsConfiguration : AsciiDownloadFieldsConfiguration = {
    toolLabel: 'ascii_dl',
    generatePartialLettering: {
        visible: false,
        defaultValue: false
    },
    accountingEntryNumberMode: {
        visible: false,
        defaultValue: AccountingEntryNumberModeEnum.NONE
    },
    fileCurrency: {
        visible: true,
        defaultValue: AsciiFileCurrencyOptionEnum.EUR
    },
    documentOption: {
        visible: false,
        defaultValue: DocumentOptionEnum.ALL_LINES
    },
    entryLabelCodeMapping: {
        visible: true,
        defaultValue: false
    },
    removeSpecialCharacters: {
        visible: true,
        defaultValue: false
    },
    letteringScope: {
        defaultValue: LetteringScopeEnum.BY_ACCOUNT,
        visible: false
    }
}